import { render } from "./OrderInterpretation.vue?vue&type=template&id=416904ce&scoped=true"
import script from "./OrderInterpretation.vue?vue&type=script&lang=js"
export * from "./OrderInterpretation.vue?vue&type=script&lang=js"

import "./OrderInterpretation.vue?vue&type=style&index=0&id=416904ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-416904ce"

export default script